export interface NewsArticle {
  _id: string
  title: string
  content: string
  excerpt?: string
  imageUrl: string
  imageAlt?: string
  galleryImages?: string[]
  authorName: string
  authorId: string
  category?: string
  tags?: string[]
  status: 'published' | 'draft' | 'archived'
  slug?: string
  metaTitle?: string
  metaDescription?: string
  ogImage?: string
  source?: string
  publishedAt?: string
  views?: number
  creator: string
  createdAt: string
  updatedAt: string
}

export interface Banner {
  _id: string
  title: string
  mediaUrl: string
  mediaType: 'image' | 'video' | 'gif'
  linkUrl?: string
  position: 'header' | 'between_articles'
  isActive: boolean
  order?: number
  creator: string
  createdAt: string
  updatedAt: string
}

export type UserModuleAccess =
  | 'banners'
  | 'landing'
  | 'depoimentos'
  | 'parceiros'
  | 'redes-sociais'
  | 'doacoes'
  | 'equipe'
  | 'mensagens'

export interface ModulePermission {
  view: boolean
  edit: boolean
  delete: boolean
}

export type ModulePermissions = Partial<Record<UserModuleAccess, ModulePermission>>

export const USER_MODULE_LABELS: Record<UserModuleAccess, string> = {
  banners: 'Banners',
  landing: 'Configurar Landing',
  depoimentos: 'Depoimentos',
  parceiros: 'Parceiros',
  'redes-sociais': 'Redes Sociais',
  doacoes: 'Doações',
  equipe: 'Nossa Equipe',
  mensagens: 'Mensagens de Contato',
}

export const ALL_USER_MODULES: UserModuleAccess[] = [
  'banners',
  'landing',
  'depoimentos',
  'parceiros',
  'redes-sociais',
  'doacoes',
  'equipe',
  'mensagens',
]

export interface UserProfile {
  _id: string
  userId: string
  displayName: string
  email?: string
  permission: 'admin' | 'user'
  modules?: UserModuleAccess[]
  modulePermissions?: ModulePermissions
  avatarUrl?: string
  bio?: string
  isActive?: boolean
  creator: string
  createdAt: string
  updatedAt: string
}

export interface SiteSetting {
  _id: string
  key: string
  value: string
  category?: string
  creator: string
  createdAt: string
  updatedAt: string
}

export interface Donation {
  _id: string
  donorName: string
  donorCpf: string
  amount: number
  pixKey?: string
  status: 'pending' | 'confirmed' | 'rejected' | 'deleted'
  receiptUrl?: string
  notes?: string
  deletedBy?: string
  deletedAt?: string
  creator: string
  createdAt: string
  updatedAt: string
}

export interface Testimonial {
  _id: string
  text: string
  authorName: string
  authorRole?: string
  photoUrl?: string
  status: 'pending' | 'approved' | 'rejected'
  creator: string
  createdAt: string
  updatedAt: string
}

export interface ContactMessage {
  _id: string
  name: string
  email: string
  phone?: string
  message: string
  status: 'unread' | 'read' | 'replied'
  creator: string
  createdAt: string
  updatedAt: string
}

export interface Partner {
  _id: string
  name: string
  logoUrl?: string
  website?: string
  isActive?: boolean
  order?: number
  creator: string
  createdAt: string
  updatedAt: string
}

export interface TeamMember {
  _id: string
  name: string
  role: string
  photoUrl?: string
  order: number
  isActive: boolean
  creator: string
  createdAt: string
  updatedAt: string
}
